;
((userInfo, ajaxCart, firebase) => {
  const $ = document.querySelector.bind(document),
    $$ = document.querySelectorAll.bind(document);
  class MoochiHelper {
    constructor() {
      this.initFirebase();
      this.initData();
    }
    initFirebase() {
      // firebase
      this.app = firebase.initializeApp({
        apiKey: 'AIzaSyALtcV8CN91VD-bKjBkmZd9Ed9G4b9OrVM',
        authDomain: 'moochi-money-logs.firebaseapp.com',
        projectId: 'moochi-money-logs',
        storageBucket: 'moochi-money-logs.appspot.com',
        messagingSenderId: '203318610175',
        appId: '1:203318610175:web:f52f76f4986eb47fb3e4ca'
      });
      this.db = firebase.firestore();
    }
    initData() {
      this.options = {
        method: 'POST',
        headers: {
          'custom-token': userInfo?.token,
          'Content-Type': 'application/json'
        },
        body: null,
        redirect: 'follow'
      };
      this.allPayments = [];
      this.cname = `U${userInfo.id}`;
      this.proxy_prefix = '/a/ps';
      // dynamic variables
      this.node = null;
      this.card_number = null;
      this.amount = null;
      this.error = null;
      // fetch cart first items properties
      window.ShopifyAPI.getCart(this.update_payments.bind(this));
    }
    update_payments(cart) {
      if (cart.items.length === 0) return;
      let item = cart.items[0];
      this.allPayments = item?.properties?._deferred_payments || [];
    }
    current_date() {
      let date = new Date();
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    }
    log_only(data, action, fn) {
      this.db.collection(this.cname).add({
        date: this.current_date(),
        action,
        data
      }).then(docRef => {
        console.log(`Log success: ${action}`);
        if (fn === undefined || typeof fn !== 'function') return;
        fn.bind(this)();
      }).catch(err => {
        console.error(`Log error: ${action}!`, err);
        if (fn === undefined || typeof fn !== 'function') return;
        fn.bind(this)();
      });
    }
    check_with_log(data, fn) {
      this.db.collection(this.cname).add({
        date: this.current_date(),
        action: 'Check Voucher',
        data: data
      }).then(docRef => {
        console.log(`Log success: Check Voucher`);
        if (data?.amount !== undefined) delete data['amount'];
        this.options.body = JSON.stringify(data);
        this.check_voucher(this.apply_voucher.bind(this));
      }).catch(err => {
        console.error('Log error!', err);
        if (fn === undefined || typeof fn !== 'function') return;
        fn();
      });
    }
    apply_without_check(data, fn) {
      this.db.collection(this.cname).add({
        date: this.current_date(),
        action: 'Apply Moochi Money',
        data: data
      }).then(docRef => {
        console.log('Log success: Apply Moochi Money');
        this.apply_money();
      }).catch(err => {
        console.log('Log error: Moochi Money', err);
        if (fn === undefined || typeof fn !== 'function') return;
        fn();
      });
    }
    check_voucher(fn) {
      fetch(`${this.proxy_prefix}/${userInfo.id}/check_before_apply`, this.options).then(res => res.json()).then(res => {
        if (res?.status !== 0) {
          this.error.innerText = res?.message || 'An error occurred!';
          this.error.classList.remove('hide');
          this.hide_loading();
          return;
        }
        this.apply_voucher();
      }).catch(err => {
        console.error('ProxyAPI error!', err);
        alert(err);
      });
    }
    update_properties() {
      // Get Cart
      window.ShopifyAPI.getCart(cart => {
        if (cart.items.length === 0) {
          alert('Your cart is empty!');
          return this.hide_loading();
        }

        // Check if any sale items in cart - if so apply moochi money to first non-sale item
        const lineIndex = cart.items.findIndex(item => item.properties?._is_sale !== 'true');
        if (lineIndex == -1) {
          lineIndex = 0;
        }

        // update properties
        window.ShopifyAPI.changeProperties(lineIndex + 1, cart.items[lineIndex].quantity, {
          _deferred_payments: this.allPayments
        }, cart => this.log_only(cart, 'Changed Properties', () => {
          this.hide_loading();
          this.update_payments(cart);
          ajaxCart.adjustSidebarCallback(cart);
          ajaxCart.adjustMiniCartCallback(cart);
        }));
      });
    }
    update_cart_attributes() {
      // Get Cart
      window.ShopifyAPI.getCart(cart => {
        if (cart.items.length === 0) {
          alert('Your cart is empty!');
          return this.hide_loading();
        }

        // Check if any sale items in cart
        const hasSaleItems = cart.items.every(item => item.properties?._is_sale === 'true');

        // Only update cart attribute if there are non-sale items
        if (!hasSaleItems) {
          // update cart attributes
          window.ShopifyAPI.updateCartAttribute('_deferred_payments', this.allPayments, cart => this.log_only(cart, 'Changed Cart Attributes', () => {
            this.hide_loading();
            this.update_payments(cart);
            ajaxCart.adjustSidebarCallback(cart);
            ajaxCart.adjustMiniCartCallback(cart);
          }));
        } else {
          this.hide_loading();
          alert('Cannot apply to cart with only sale items');
        }
      });
    }
    apply_voucher() {
      this.allPayments.push({
        type: 'GiftCard',
        currency: window.theme.currency,
        card_number: this.card_number,
        value: parseInt(this.amount * 100)
      });
      this.update_properties();
    }
    apply_money() {
      this.allPayments.push({
        type: 'Loyalty',
        currency: window.theme.currency,
        loyalty_point: this.amount,
        loyalty_programme: 'Moochi Loyalty',
        value: parseInt(this.amount * 100)
      });
      this.update_cart_attributes();
    }
    show_loading(node) {
      this.node = node;
      ajaxCart.setStatus(true);
      this.node.classList.add('loading');
    }
    hide_loading() {
      ajaxCart.setStatus(false);
      this.node.classList.remove('loading');
    }
    async add_giftcard(node) {
      const hasSaleOnCart = await this.check_sale_items();
      if (hasSaleOnCart) {
        this.show_sales_message('.apply-gift-card', 'gift cards cannot be used on sale items');
        return;
      }
      let container = node.closest('.gift-cards.accordion') || document.querySelector('.gift-cards.accordion');
      if (!container) {
        return alert('Oops... something went wrong while adding the gift card!');
      }
      let selector = container.querySelector('.ajaxcart__gc-id');
      this.error = container.querySelector('.form-error');
      this.card_number = node.dataset?.id || selector.value;
      this.amount = node.dataset?.amount || selector.selectedOptions[0].dataset?.amount;
      if (!this.card_number || this.card_number === '') return alert('Card number is empty!');
      if (!this.amount || this.amount === '') return alert('Card amount is empty!');
      this.show_loading(node);
      this.check_with_log({
        card_number: this.card_number,
        amount: this.amount
      }, () => this.hide_loading());
    }
    async add_moochi_money(node) {
      const hasSaleOnCart = await this.check_sale_items();
      if (hasSaleOnCart) {
        this.show_sales_message('.apply-moochi-money', 'moochi money cannot be used on sale items.');
        return;
      }
      let container = $('.moochi-money-balance.accordion'),
        selector = container.querySelector('.ajaxcart__mm-amount');
      this.amount = node.dataset?.amount || selector?.value;
      if (!this.amount) return alert('Can`t find the amount');
      this.show_loading(node);
      this.apply_without_check({
        loyalty_point: this.amount,
        value: parseInt(this.amount * 100)
      }, () => this.hide_loading());
    }
    remove_giftcard(node) {
      this.card_number = node.dataset?.id;
      if (!this.card_number) return alert('Cart number is invalid!');
      this.allPayments = this.allPayments.filter(obj => obj.card_number !== this.card_number);
      this.log_only(this.allPayments, 'Remove GiftCard', () => {
        this.show_loading(node);
        this.update_properties();
      });
    }
    async check_sale_items() {
      return new Promise((resolve, reject) => {
        window.ShopifyAPI.getCart(cart => {
          const hasSaleItems = cart.items.every(item => item.properties?._is_sale === 'true');
          if (hasSaleItems) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    }
    show_sales_message(selector, text) {
      let salesMessage = document.createElement('p');
      salesMessage.innerHTML = text;
      salesMessage.classList.add('description');
      const element = document.querySelector(selector);
      element.insertAdjacentElement('afterend', salesMessage);
      setTimeout(() => {
        salesMessage.remove();
      }, 6000);
    }
    remove_moochi_money(node) {
      this.allPayments = this.allPayments.filter(obj => obj.type !== 'Loyalty');
      this.log_only(this.allPayments, 'Remove MoochiMoney', () => {
        this.show_loading(node);
        this.update_cart_attributes();
      });
    }
  }
  var moochi_helper = new MoochiHelper();

  // bind event
  document.body.addEventListener('click', el => {
    // check user login or not
    if (userInfo?.id !== undefined && userInfo.id === '') return;
    let firstNode = el.target;
    if (firstNode.nodeName === 'SPAN') firstNode = firstNode.parentElement;
    let found = ['ajaxcart__mm-apply', 'ajaxcart__mm-remove', 'ajaxcart__gc-apply', 'ajaxcart__gc-remove'].find(v => firstNode.classList.contains(v));
    if (firstNode.nodeName !== 'A' || found === undefined) return;
    el.preventDefault();
    // process data
    if (ajaxCart.getStatus()) return alert('The cart is updating, please try again later!');
    switch (found) {
      case 'ajaxcart__gc-remove':
        moochi_helper.remove_giftcard(firstNode);
        break;
      case 'ajaxcart__gc-apply':
        moochi_helper.add_giftcard(firstNode);
        break;
      case 'ajaxcart__mm-apply':
        moochi_helper.add_moochi_money(firstNode);
        break;
      case 'ajaxcart__mm-remove':
        moochi_helper.remove_moochi_money(firstNode);
        break;
    }
  });
})(window.userInfo, window.ajaxCart, window.firebase);